import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const LatestRelease = {
    albumOrSingle: "Single",
    title: "Already Home",
    duration: "03:15",
    slogan: "For when you need to feel safe",
    embeds: [
        {
            id: "alreadyhome-track",
            videoID: "sfcZPp7rkVw",
            caption: "Listen"
        }
    ],
    cover: {
        name: "alreadyHomeSingleCover.jpg",
        path: require("../assets/covers/alreadyHomeSingleCover.jpg"),
        image: (
            <img src={require("../assets/covers/alreadyHomeSingleCover.jpg")} alt="Already Home Single Cover" />
        )
    },
    links: [
        {
            platform: "Spotify",
            link: "https://open.spotify.com/track/5IQ7PfwCp3YQZXcfRPXWf8",
            icon: (
                <FontAwesomeIcon
                    icon="fa-brands fa-spotify"
                    className="icon"
                />
            )
        },
        {
            platform: "Apple Music",
            link: "https://music.apple.com/us/song/already-home/1886406132",
            icon: (
                <FontAwesomeIcon
                    icon="fa-brands fa-itunes-note"
                    className="icon"
                />
            )
        },
        {
            platform: "Amazon Music",
            link: "https://music.amazon.ca/albums/B0GT3RGXKG&trackAsin=B0GT3MY1GQ",
            icon: (
                <FontAwesomeIcon
                    icon="fa-brands fa-amazon"
                    className="icon"
                />
            )
        },
        {
            platform: "YouTube",
            link: "https://youtu.be/sfcZPp7rkVw?si=fbI3bU0HI-7d92YI",
            icon: (
                <FontAwesomeIcon
                    icon="fa-brands fa-youtube"
                    className="icon"
                />
            )
        }
    ]
};

export const Singles = [
    {
        id: "alone",
        title: "Alone",
        duration: "03:31",
        slogan: "For when you feel invisible",
        cover: {
            name: "aloneSingleCover.jpg",
            path: require("../assets/covers/aloneSingleCover.jpg"),
            image: (
                <img src={require("../assets/covers/aloneSingleCover.jpg")} alt="Alone Single Cover" />
            )
        },
        embeds: [
            {
                id: "alone-track",
                videoID: "KkX2Q72aWnA",
                caption: "Listen"
            },
            {
                id: "alone-lvideo",
                videoID: "avXLSHr6270",
                caption: "Lyric Video"
            }
        ],
        links: [
            {
                platform: "Spotify",
                link: "https://open.spotify.com/track/2M6b4hQhDTBkuIp7mnzu0j",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-spotify"
                        className="icon"
                    />
                )
            },
            {
                platform: "Apple Music",
                link: "https://music.apple.com/album/1790603298?i=1790603689",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-itunes-note"
                        className="icon"
                    />
                )
            },
            {
                platform: "Amazon Music",
                link: "https://music.amazon.ca/albums/B0DSW4Q4H6?trackAsin=B0DSW46YNM",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-amazon"
                        className="icon"
                    />
                )
            },
            {
                platform: "YouTube",
                link: "https://youtu.be/KkX2Q72aWnA?si=aNhN2HshDlHvDJNJ",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-youtube"
                        className="icon"
                    />
                )
            }
        ],
        videos: [
            {
                platform: "YouTube",
                link: "https://youtu.be/avXLSHr6270?si=z7Xf9uegm9GHNyFZ",
                type: "Lyric Video",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-youtube"
                        className="icon"
                    />
                )
            },
            {
                platform: "Apple Music",
                link: "https://music.apple.com/ca/music-video/alone-lyric-video/1800407733",
                type: "Lyric Video",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-itunes-note"
                        className="icon"
                    />
                )
            }
        ]
    },
    {
        id: "setaside",
        title: "Set Aside",
        duration: "03:00",
        slogan: "For when you've been burned",
        cover: {
            name: "setAsideSingleCover.jpg",
            path: require("../assets/covers/setAsideSingleCover.jpg"),
            image: (
                <img src={require("../assets/covers/setAsideSingleCover.jpg")} alt="Set Aside Single Cover" />
            )
        },
        embeds: [
            {
                id: "setaside-track",
                videoID: "PvvLcZYL090",
                caption: "Listen"
            },
            {
                id: "setaside-lvideo",
                videoID: "bXJfFbZbD5s",
                caption: "Lyric Video"
            }
        ],
        links: [
            {
                platform: "Spotify",
                link: "https://open.spotify.com/track/0CwALlGhi1cbRpEteOV3zE",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-spotify"
                        className="icon"
                    />
                )
            },
            {
                platform: "Apple Music",
                link: "https://music.apple.com/album/1815105738?i=1815105739",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-itunes-note"
                        className="icon"
                    />
                )
            },
            {
                platform: "Amazon Music",
                link: "https://music.amazon.ca/albums/B0F91XPFVV?trackAsin=B0F9227758",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-amazon"
                        className="icon"
                    />
                )
            },
            {
                platform: "YouTube",
                link: "https://youtu.be/PvvLcZYL090?si=tejSIdLGEarZebJw",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-youtube"
                        className="icon"
                    />
                )
            }
        ],
        videos: [
            {
                platform: "YouTube",
                link: "https://youtu.be/bXJfFbZbD5s?si=qLJ1WyTbi566Z5sq",
                type: "Lyric Video",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-youtube"
                        className="icon"
                    />
                )
            },
            {
                platform: "Apple Music",
                link: "https://music.apple.com/ca/music-video/set-aside-lyric-video/1856715059",
                type: "Lyric Video",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-itunes-note"
                        className="icon"
                    />
                )
            }
        ]
    },
    {
        id: "teachme",
        title: "Teach Me (All I Know)",
        duration: "04:36",
        slogan: "For when you need yourself",
        cover: {
            name: "teachMeSingleCover.jpg",
            path: require("../assets/covers/teachMeSingleCover.jpg"),
            image: (
                <img src={require("../assets/covers/teachMeSingleCover.jpg")} alt="Teach Me (All I Know) Single Cover" />
            )
        },
        embeds: [
            {
                id: "teachme-track",
                videoID: "CE-LFGWAx_0",
                caption: "Listen"
            }
        ],
        links: [
            {
                platform: "Spotify",
                link: "https://open.spotify.com/track/7bYRi804wbImcnx7Vx4eGM",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-spotify"
                        className="icon"
                    />
                )
            },
            {
                platform: "Apple Music",
                link: "https://music.apple.com/album/1831870807?i=1831870808",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-itunes-note"
                        className="icon"
                    />
                )
            },
            {
                platform: "Amazon Music",
                link: "https://music.amazon.ca/albums/B0FLHGNYN5?trackAsin=B0FLHC51F2",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-amazon"
                        className="icon"
                    />
                )
            },
            {
                platform: "YouTube",
                link: "https://youtu.be/CE-LFGWAx_0?si=Z-UpMsCbScq1uZf7",
                icon: (
                    <FontAwesomeIcon
                        icon="fa-brands fa-youtube"
                        className="icon"
                    />
                )
            }
        ],
        videos: [
            
        ]
    }
];